<template>
  <div :class="'pc-wrapping '+ thisBackGroup">
    <!-- 头部 -->
    <div class="pc-header">
      <!-- logo -->
      <div class="pc-logo">
        <el-image :src="logoUrl"></el-image>
      </div>
      <!-- 导航菜单 -->
      <div class="pc-menu">
        <div
          class="pc-menu-item"
          :class="activeMenu==='home'?'pc-menu-item-active':''"
          @click="handleClickMenuItem('home')"
        >HOME</div>
        <div
          class="pc-menu-item"
          :class="activeMenu==='aboutUs'?'pc-menu-item-active':''"
          @click="handleClickMenuItem('aboutUs')"
        >ABOUT US</div>
        <div
          class="pc-menu-item"
          :class="activeMenu==='contactUs'?'pc-menu-item-active':''"
          @click="handleClickMenuItem('contactUs')"
        >CONTACT US</div>
      </div>
      <!-- 商标 -->
      <div class="pc-certified">
        <div style="margin-left:10%;">
          <a href="https://access.gaminglabs.com/Certificate/Index?i=370" target="_blank">
            <el-image :src="certifiedUrl"></el-image>
          </a>
        </div>
      </div>
    </div>

    <!-- 内容 -->
    <div class="pc-content">
      <!-- home-内容 -->
      <div v-show="activeMenu==='home'" class="pc-content-home">
        <div class="change-home-box-left">
          <el-button
            icon="el-icon-arrow-left"
            class="change-home-box"
            @click="handleHomeLeftChange"
          ></el-button>
        </div>

        <div class="change-home-box change-home-box-right">
          <el-button
            icon="el-icon-arrow-right"
            class="change-home-box"
            @click="handleHomeRightChange"
          ></el-button>
        </div>

        <!-- 平台 -->
        <div class="pc-platform">
          <div></div>
          <div class="pc-platform-box">
            <div>

              <div class="pc-platform-item" v-for="(platform, index) in platforms" :key="index">
                <a :href="platform.link" :target="platform.target" >
                  <el-image :src="platform.pcIcon" class="pc-platform-item-image"></el-image>
                </a>
              </div>

            </div>
          </div>

          <div></div>
        </div>

         <div class="pc-home-radio">
            <div class="pc-home-radio-item">
              <img
                v-if="thisBackGroup ==='backgroup-1'"
                :src="blackUrl"
                alt
                @click="handleClickRadio(1)"
              />
              <img v-else :src="whiteUrl" alt @click="handleClickRadio(1)" />
            </div>
            <div class="pc-home-radio-item">
              <img
                v-if="thisBackGroup ==='backgroup-2'"
                :src="blackUrl"
                alt
                @click="handleClickRadio(2)"
              />
              <img v-else :src="whiteUrl" alt @click="handleClickRadio(2)" />
            </div>
            <div class="pc-home-radio-item">
              <img
                v-if="thisBackGroup ==='backgroup-3'"
                :src="blackUrl"
                alt
                @click="handleClickRadio(3)"
              />
              <img v-else :src="whiteUrl" alt @click="handleClickRadio(3)" />
            </div>
          </div>

      </div>

      <!-- aboutUs-内容 -->
      <div v-show="activeMenu==='aboutUs'" class="pc-content-about-us">
        <!-- 主图 -->
        <div class="pc-main-image-about-us">
          <el-image :src="aboutUsUrl"></el-image>
        </div>
      </div>

      <!-- contactUs-内容 -->
      <div v-show="activeMenu==='contactUs'" class="pc-content-contact-us">
        <!-- 主图 -->
        <div class="pc-main-image-contact-us">
          <el-image :src="contactUsUrl" usemap="#planetmap"></el-image>
        </div>

        <map name="planetmap" id="planetmap">
          <area shape="rect" coords="80, 400, 470, 460" alt="Sun" />
          <area shape="rect" coords="300, 670, 630, 610" alt="Sun" />
        </map>
      </div>
    </div>

    <!-- 底部 -->
    <div class="pc-footer">
      <div class="pc-footer-info">
        <x-foot/>
      </div>
    </div>

    <!-- 预加载 防止切背景闪屏 -->
    <div class="backgroup-2"></div>
    <div class="backgroup-3"></div>
  </div>
</template>

<script>
import logo from '@/assets/images/home/pc/logo.png'
import certified from '@/assets/images/home/pc/certified.jpg'
import aboutUs from '@/assets/images/home/pc/about_us_main.png'
import contactUs from '@/assets/images/home/pc/contact_us_main.png'
import white from '@/assets/images/home/pc/white.png'
import black from '@/assets/images/home/pc/black.png'
import platformConfig from '@/util/platform'
import foot from '@/views/components/foot'

export default {
  name: 'HomeIndexPc',
  components: {
    'x-foot': foot
  },
  data () {
    return {
      logoUrl: logo,
      certifiedUrl: certified,
      aboutUsUrl: aboutUs,
      contactUsUrl: contactUs,
      whiteUrl: white,
      blackUrl: black,
      activeMenu: 'home',
      thisBackGroup: 'backgroup-1',
      intervalTime: 3000,
      platforms: [],
      thisInterval: ''
    }
  },
  mounted () {
    this.reloadInterval()
    this.platforms = platformConfig.kr.home
  },
  methods: {
    handleClickRadio (type) {
      this.intervalTime = 10000

      this.reloadInterval()
      this.thisBackGroup = 'backgroup-' + type
    },
    reloadInterval () {
      const _that = this
      window.clearInterval(this.thisInterval)
      this.thisInterval = window.setInterval(function () {
        switch (_that.thisBackGroup) {
          case 'backgroup-1': {
            _that.thisBackGroup = 'backgroup-2'
            break
          }
          case 'backgroup-2': {
            _that.thisBackGroup = 'backgroup-3'
            break
          }
          case 'backgroup-3': {
            _that.thisBackGroup = 'backgroup-1'
            break
          }
        }
      }, _that.intervalTime)
    },
    handleClickMenuItem (activeMenu) {
      switch (activeMenu) {
        case 'home': {
          this.thisBackGroup = 'backgroup-1'
          break
        }
        case 'aboutUs': {
          this.thisBackGroup = 'backgroup-0'
          break
        }
        case 'contactUs': {
          this.thisBackGroup = 'backgroup-0'
          break
        }
      }

      this.activeMenu = activeMenu
    },
    handleJumpTo (name) {
      const { href } = this.$router.resolve({
        name: name
      })
      window.open(href, '_blank')
    },
    handleHomeLeftChange () {
      switch (this.thisBackGroup) {
        case 'backgroup-1': {
          this.thisBackGroup = 'backgroup-3'
          break
        }
        case 'backgroup-2': {
          this.thisBackGroup = 'backgroup-1'
          break
        }
        case 'backgroup-3': {
          this.thisBackGroup = 'backgroup-2'
          break
        }
        default:
          this.thisBackGroup = 'backgroup-1'
      }
    },
    handleHomeRightChange () {
      switch (this.thisBackGroup) {
        case 'backgroup-1': {
          this.thisBackGroup = 'backgroup-2'
          break
        }
        case 'backgroup-2': {
          this.thisBackGroup = 'backgroup-3'
          break
        }
        case 'backgroup-3': {
          this.thisBackGroup = 'backgroup-1'
          break
        }
        default:
          this.thisBackGroup = 'backgroup-1'
      }
    }
  }
}
</script>

<style scoped>
.pc-wrapping {
  background: url('~@/assets/images/home/pc/backgourp_image.jpg') repeat-x;
  position: fixed;
  width: 100%;
  height: 100%;
  min-width: 1000px;
}

/* no*/

.pc-header {
  width: 100%;
  display: -webkit-flex;
  display: flex;
  align-items: flex-end;
  justify-content: space-around;

  margin-top: 40px;
}

/* no*/

.pc-logo {
  width: 270px;
  height: 50px;
  -webkit-flex: 1;
  flex: 1;
}

/* no*/

.pc-menu {
  z-index: 100;
  align-content: center;
  text-align: center;
  align-self: flex-end;
  justify-content: center;
  -webkit-flex: 3;
  flex: 3;
  display: flex;
}

/* no*/

.pc-menu-item {
  margin: auto 20px;
  font-size: 24px;
  color: #63b8e4;
  cursor: pointer;
  position: relative;
}

/* no*/

.pc-menu-item-active {
  color: #ceeaff;
  padding-bottom: 5px;
  border-bottom: 2px solid #ceeaff;
}

/* no*/

.pc-certified {
  width: 114px;
  height: 40px;
  -webkit-flex: 1;
  flex: 1;
}

/* no*/

.pc-main-image {
  width: 46%;
  margin: 0 auto;
}

/* no*/

.pc-platform {
  width: 100%;
  display: flex;
  align-content: center;
  justify-content: center;
  text-align: center;
  position: fixed;
  left: 50%;
  bottom: 10%;
  transform: translate(-50%, -50%);
}

/* no*/

.pc-platform-box {
  margin: 0 auto;
  text-align: center;
}

/* no*/

.pc-platform-item {
  display: inline-block;
  margin-top: 0;
  margin-bottom: 0;
  margin-right: 10px;
}

/* no*/

.pc-platform-item-image {
  border-radius: 10px; /* no*/
}

.pc-home-radio{

  display: flex;
  align-content: center;
  justify-content: center;
  text-align: center;
  position: fixed;
  left: 50%;
  bottom: 10%;
  transform: translate(-50%, -50%);
}

.pc-home-radio-item{
    margin-right: 10px;/* no*/
    cursor: pointer;
}

/* no*/

.pc-main-image-about-us {
  width: 70%;
  margin: 0 auto;
}

/* no*/

.pc-content-contact-us {
  position: relative;
  margin: 0 auto;
  width: 550px; /* no*/
}

/* no*/

.pc-main-image-contact-us {
  margin: 0 auto;
  position: relative;
  z-index: 99;
  /* bottom: 200px; */
} /* no*/

.pc-footer {
  text-align: center;
  width: 100%;
  position: fixed;
  bottom: 50px;
  display: flex;
  align-content: center;
  justify-content: center;
} /* no*/

.pc-footer-info {
  width: 100%;
  height: 28px;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 19px;
  letter-spacing: 0px;
  color: #d2d7e5;
} /* no*/

.pc-footer-info a {
  cursor: pointer;
}

.backgroup-1 {
  background-image: url('~@/assets/images/home/pc/home_main1.jpg');
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.backgroup-2 {
  background-image: url('~@/assets/images/home/pc/home_main2.jpg');
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.backgroup-3 {
  background-image: url('~@/assets/images/home/pc/home_main3.jpg');
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.change-home-box {
  background-color: transparent;
  border-color: transparent;
  font-size: 74px; /* no*/
  color: white;
  opacity: 0.6;
}

.change-home-box-left {
  position: absolute;
  top: 50%;
  left: 10%;
  transform: translate(-50%, -50%);
}

.change-home-box-right {
  position: absolute;
  top: 50%;
  right: 10%;
  transform: translate(50%, -50%);
}

</style>



// WEBPACK FOOTER //
// src/views/home/lang/kr/pc.vue